import React from "react";
import {MainCP}  from "../../Components/desempleo-vs-expectativas/MainCP"

const ViewDesempleoexp: React.FC = () => <MainCP/>

export default ViewDesempleoexp;